import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useThunk } from "../../hooks/useThunk";
import { sendSupportRequest } from "../../store";
import { fetchUserProperties } from "../../store";
import FormWrapper from "../../components/Common/FormWrapper";
import showToast from "../../utils/toastNotifications";
import { supportRequestTypes } from "../../constants/commonConstants";

const MAX_LABEL = 24;

const ReqMaintaince = () => {
  const [selectedTenant, setSelectedTenant] = useState("");
  const [description, setDescription] = useState("");
  const [touched, setTouched] = useState(false);
  const [dropdownError, setDropdownError] = useState("");
  const [textareaError, setTextareaError] = useState("");
  const [doSendRequest, isLoading, error] = useThunk(sendSupportRequest);
  const [doFetchUserProperties, isFetchUserProperties, fetchUserPropertiesError] = useThunk(fetchUserProperties);
  
  const properties = useSelector((state) => state.property.properties);

  const loadUserProperties = async () => {
    const result = await doFetchUserProperties();
    if (result?.success) {
      // console.log("Properties fetched successfully:");
    } else {
      console.error("Error fetching properties:", result?.error?.message);
    }
  }

  useEffect(() => {
    if (!properties.length > 0) {
      loadUserProperties();
    }
  }, []);

  const unitsWithTenants = useMemo(() => {
    if (!Array.isArray(properties)) return [];
    return properties
      .flatMap(property =>
        (property.units || [])
          .filter(unit => unit.tenant)
          .map(unit => {
            const fullLabel = `${unit.tenant.name} (Unit ${unit.unitName})`;
            const isLong = fullLabel.length > MAX_LABEL;
            const label = isLong ? fullLabel.slice(0, MAX_LABEL - 1) + "…" : fullLabel;
            return {
            value: unit._id,
            tenantId: unit.tenant._id,
              label,
              fullLabel,
              isLong,
            };
          })
      );
  }, [properties]);

  const handleLegalSubmit = async() => {

    if (!description.trim() || description.trim().length > 1000){
      showToast("error", "Please fill all required fields correctly.");
      return;
    }

    const data = {
      unitId: selectedTenant?.value || "",
      tenantId: selectedTenant?.tenantId || "",
      description: description.trim(),
      requestType: supportRequestTypes.MAINTENANCE,
    }

    const result = await doSendRequest(data);

    if (result?.success) {
      showToast("success", "Maintenance request submitted.");
    } else {
      showToast("error", result?.error?.message);
    }
  };

  return (
    <div className="p-4 sm:p-6 md:p-[30px]">
      <div className="flex justify-center">
        <div className="w-full">
          <FormWrapper
            wrapperHeight="h-[604px] sm:h-[620px] md:h-[630px] lg::h-[638px]"
            //dropdown
            dropdownLabel="Select Unit or Tenant"
            dropdownPlaceholder="All units and active tenants"
            dropdownOptions={unitsWithTenants}
            dropdownValue={selectedTenant}
            dropdownRequired={false}
            onDropdownChange={(selected) => setSelectedTenant(selected)}
            // dropdownError={dropdownError}
            dropdownFormatOptionLabel={(option) => (
              <span
                title={option.isLong ? option.fullLabel : undefined}
                className="block max-w-[28ch] overflow-hidden text-ellipsis whitespace-nowrap"
              >
                {option.label}
              </span>
            )}
            dropdownSingleValueRenderer={({ data }) => (
              <span
                title={data?.isLong ? data.fullLabel : undefined}
                className="block max-w-[28ch] overflow-hidden text-ellipsis whitespace-nowrap"
              >
                {data?.label}
              </span>
            )}
            // textarea
            textareaLabel="Reason / Description"
            textareaPlaceholder="Briefly describe the issue (e.g., plumbing leak, broken light)"
            textareaValue={description}
            textareaRequired={true}
            onTextareaChange={(e) => {
              setDescription(e.target.value);
              setTouched(true);
            }}
            textareaError={
              touched && !description.trim()
                ? "This field is required."
                : touched &&  description.trim().length > 1000
                ? "Description must be less than 1000 characters."
                : ""
            }

            // button
            buttonLabel="Submit"
            onSubmit={handleLegalSubmit}
            loading={isLoading}
            disabled={isLoading || !description.trim()}
            required
          />
        </div>
      </div>
    </div>
  );
};

export default ReqMaintaince;

